import { render, staticRenderFns } from "./TranscriptVerified.vue?vue&type=template&id=a6a8ebe4&scoped=true&"
import script from "./TranscriptVerified.vue?vue&type=script&lang=js&"
export * from "./TranscriptVerified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a8ebe4",
  null
  
)

export default component.exports